import http, {SuccessEvent} from "../../common/ts/core/http";
import {EventBus} from "../../common/ts/events/EventBus";

let eventBus: EventBus;
function retrieveSerpClickSimilarAds(
    params: {
        id: string,
        q: string,
        number: number,
        ids: string,
        currentOrigin: string
        pageViewId: string,
    },
    successEvent: SuccessEvent
) {
    return new http.GetEvent({
        url: `/internal/mitula/serp/similar-click`,
        params,
        successEvent,
    })
}

function retrieveDetailTrafficClickSimilarAds(
    params: {
        id: string,
        ids: string,
        searchTerms: string,
        pageViewId: string,
    },
    successEvent: SuccessEvent
) {
    return new http.GetEvent({
        url: `/internal/mitula/detail/traffic/similar-click`,
        params,
        successEvent,
    })
}

export default {
    events: {
        retrieveSerpClickSimilarAds,
        retrieveDetailTrafficClickSimilarAds,
    }
}
